import { render } from "./EventAttendanceList.vue?vue&type=template&id=1d88d33a&scoped=true"
import script from "./EventAttendanceList.vue?vue&type=script&lang=js"
export * from "./EventAttendanceList.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d88d33a"]])

export default __exports__